export const mockArtworks = [
  {
    id: 1,
    title: 'Chromatic Dissolution',
    year: '2024',
    medium: 'Mixed Media on Canvas',
    dimensions: '120 x 100 cm',
    image: 'https://images.unsplash.com/photo-1541512416146-3cf58d6b27cc',
    detail: 'https://images.unsplash.com/photo-1578321272176-b7bbc0679853',
    scene: 'https://images.unsplash.com/photo-1615529182904-14819c35db37',
    category: 'works',
    available: true,
    price: 2800.00
  },
  {
    id: 2,
    title: 'Ethereal Whispers',
    year: '2024',
    medium: 'Oil on Canvas',
    dimensions: '150 x 120 cm',
    image: 'https://images.unsplash.com/photo-1565876427310-0695a4ff03b7',
    detail: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5',
    scene: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace',
    category: 'works',
    available: false,
    price: 3500.00
  },
  {
    id: 3,
    title: 'Atmospheric Memory',
    year: '2023',
    medium: 'Acrylic on Canvas',
    dimensions: '100 x 80 cm',
    image: 'https://images.unsplash.com/photo-1567095751004-aa51a2690368',
    detail: 'https://images.unsplash.com/photo-1574182245530-967d9b3831af',
    scene: 'https://images.unsplash.com/photo-1618220179428-22790b461013',
    category: 'works',
    available: true,
    price: 2200.00
  },
  {
    id: 4,
    title: 'Temporal Fragment',
    year: '2024',
    medium: 'Mixed Media',
    dimensions: '110 x 90 cm',
    image: 'https://images.unsplash.com/photo-1618331833071-ce81bd50d300',
    detail: 'https://images.unsplash.com/photo-1551913902-c92207136625',
    scene: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0',
    category: 'works',
    available: true,
    price: 2500.00
  },
  {
    id: 5,
    title: 'Silent Resonance',
    year: '2023',
    medium: 'Oil and Gold Leaf on Canvas',
    dimensions: '130 x 100 cm',
    image: 'https://images.pexels.com/photos/1981468/pexels-photo-1981468.jpeg',
    detail: 'https://images.unsplash.com/photo-1547891654-e66ed7ebb968',
    scene: 'https://images.unsplash.com/photo-1567538096630-e0c55bd6374c',
    category: 'works',
    available: false,
    price: 3200.00
  },
  {
    id: 6,
    title: 'Luminous Decay',
    year: '2024',
    medium: 'Acrylic on Canvas',
    dimensions: '140 x 110 cm',
    image: 'https://images.pexels.com/photos/6560355/pexels-photo-6560355.jpeg',
    detail: 'https://images.unsplash.com/photo-1579541591970-e5b9d1cf06b6',
    scene: 'https://images.unsplash.com/photo-1616627451515-d8b4d96e0c1d',
    category: 'works',
    available: true,
    price: 2900.00
  }
];

export const mockSculptures = [
  {
    id: 7,
    title: 'Golden Contemplation',
    year: '2024',
    medium: 'Bronze and Gold Leaf',
    dimensions: '45 x 30 x 25 cm',
    image: 'https://images.unsplash.com/photo-1661430902921-1e5b84ea87ca',
    detail: 'https://images.unsplash.com/photo-1610701596007-11502861dcfa',
    scene: 'https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6',
    category: 'sculpture',
    available: true,
    price: 4500.00
  },
  {
    id: 8,
    title: 'Geometric Silence',
    year: '2023',
    medium: 'Marble and Steel',
    dimensions: '60 x 40 x 30 cm',
    image: 'https://images.pexels.com/photos/7799011/pexels-photo-7799011.jpeg',
    detail: 'https://images.unsplash.com/photo-1554188248-986adbb73be4',
    scene: 'https://images.unsplash.com/photo-1577083552431-6e5fd01988ec',
    category: 'sculpture',
    available: true,
    price: 5200.00
  },
  {
    id: 9,
    title: 'Metamorphic State',
    year: '2024',
    medium: 'Bronze',
    dimensions: '50 x 35 x 28 cm',
    image: 'https://images.unsplash.com/photo-1618331833071-ce81bd50d300',
    detail: 'https://images.unsplash.com/photo-1582555172866-f73bb12a2ab3',
    scene: 'https://images.unsplash.com/photo-1565183997392-2f6f122e5912',
    category: 'sculpture',
    available: false,
    price: 4800.00
  }
];

export const mockBio = `My work explores the beauty hidden within chaos.

Through abstraction, texture and instinctive mark-making, I create emotional landscapes that emerge from intuition rather than planning.

Each piece is a conversation between silence and movement — a reflection of emotions, memories and fragments that cannot always be expressed through words.

As an architect, painter and sculptor, I approach art as an act of discovery.

I allow the mind to speak freely, embracing imperfection, spontaneity and the invisible connections that appear throughout the creative process.`;
